import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";
import FormRow from "@/components/forms/FormRow.vue";
import FormInput from "@/components/forms/FormInput.vue";

import { useI18n } from "vue3-i18n";
import { min, required } from "@/validation/rules";
import {Plan, PlanType} from "@/types/entities/plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'MembershipForm',
  props: {
    value: {}
  },
  emits: ["planUpdated"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

// eslint-disable-next-line
const props = __props;

// eslint-disable-next-line
const emit = __emit;

const plan = ref(props.value)
const accountCode = ref(props.value.product?.accountingSoftwareProduct?.accountCode ?? {})
const itemCode = ref(props.value.product?.accountingSoftwareProduct?.itemCode ?? {})
const price = ref(props.value.product?.price)


const priceInputLabel = computed(() => {
  if (plan.value.type == PlanType.Syndicate)
    return t(`memberships.form.unitPrice${plan.value.unitsMin != undefined && plan.value.unitsMin > 1 ? plan.value.unitsMin : ''
      }${plan.value.unitsMax != undefined && plan.value.unitsMax > 1 ? `And${plan.value.unitsMax}` : ''}units`);
  else return t(`memberships.form.unitPrice`)
})

const accountCodeInputLabel = computed(() => {
  let label = t(`memberships.form.accountCode`)
  if (plan.value.unitsMin == null)
    label += " " + plan.value.chapter
  return label
})


watch(props, (newVal) => {
  plan.value = newVal.value
  accountCode.value = newVal.value.product?.accountingSoftwareProduct?.accountCode ?? {}
  itemCode.value = newVal.value.product?.accountingSoftwareProduct?.itemCode ?? {}
  price.value = newVal.value.product?.price
}, { immediate: true, deep: true })

watch(accountCode, (newVal) => {
  if(plan.value.product?.accountingSoftwareProduct != null)
    plan.value.product.accountingSoftwareProduct.accountCode = newVal
  emit('planUpdated', plan.value)
}, { immediate: true, deep: true })

watch(itemCode, (newVal) => {
  if(plan.value.product?.accountingSoftwareProduct != null)
  plan.value.product.accountingSoftwareProduct.itemCode = newVal
  emit('planUpdated', plan.value)
}, { immediate: true, deep: true })

watch(price, (newVal) => {
  if(plan.value.product != null){
    plan.value.product.price = newVal;
    emit('planUpdated', plan.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, { "with-three-columns": "" }, {
    default: _withCtx(() => [
      _createVNode(FormInput, {
        ref: `accountCodeEl-${plan.value.id}`,
        name: `accountCode-${plan.value.id}`,
        type: "text",
        label: accountCodeInputLabel.value,
        modelValue: accountCode.value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountCode.value.value) = $event))
      }, null, 8, ["name", "label", "modelValue"]),
      _createVNode(FormInput, {
        ref: `itemCodeEl-${plan.value.id}`,
        name: `itemCode-${plan.value.id}`,
        type: "text",
        label: _unref(t)(`memberships.form.itemCode`),
        modelValue: itemCode.value.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((itemCode.value.value) = $event))
      }, null, 8, ["name", "label", "modelValue"]),
      _createVNode(FormInput, {
        ref: `priceEl-${plan.value.id}`,
        name: `price-${plan.value.id}`,
        type: "text",
        label: priceInputLabel.value,
        rules: [_unref(min)(0), _unref(required)],
        modelValue: price.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((price).value = $event)),
        modelModifiers: { number: true }
      }, null, 8, ["name", "label", "rules", "modelValue"])
    ]),
    _: 1
  }))
}
}

})